import '../../styles/components/admin.css'
import { requireAuth, signOut, getBlogPosts, deleteBlogPost } from '../../lib/supabase.js'

export function renderAdminBlog(outlet) {
  requireAuth(async () => {
    outlet.innerHTML = `
      <div class="admin-page">
        <div class="container">
          <div class="admin-topbar">
            <h1 class="admin-title">Blog Posts</h1>
            <div style="display:flex; gap: var(--space-3); align-items:center;">
              <a href="#/admin" class="btn btn-sm">Products</a>
              <a href="#/admin/categories" class="btn btn-sm">Categories</a>
              <a href="#/admin/promo-codes" class="btn btn-sm">Promo Codes</a>
              <a href="#/admin/users" class="btn btn-sm">Customers</a>
              <a href="#/admin/blog/new" class="btn btn-primary btn-sm">+ New Post</a>
              <button class="admin-signout" id="admin-signout-btn">Sign Out</button>
            </div>
          </div>

          <div id="admin-blog-content">
            <div class="products-loading" style="padding: var(--space-16) 0; text-align:center;">
              <div class="spinner"></div>
              <span style="margin-left: var(--space-3); color: var(--color-text-secondary);">Loading posts…</span>
            </div>
          </div>
        </div>
      </div>
    `

    document.getElementById('admin-signout-btn')?.addEventListener('click', async () => {
      await signOut()
      window.location.hash = '#/admin/login'
    })

    await loadPosts()
  })
}

async function loadPosts() {
  const content = document.getElementById('admin-blog-content')
  if (!content) return

  try {
    const posts = await getBlogPosts()

    if (posts.length === 0) {
      content.innerHTML = `
        <div class="admin-empty">
          <p>No blog posts yet.</p>
          <a href="#/admin/blog/new" class="btn btn-primary" style="margin-top: var(--space-4);">Write your first post</a>
        </div>
      `
      return
    }

    content.innerHTML = `
      <div class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Slug</th>
              <th>Status</th>
              <th>Published</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody id="admin-blog-tbody">
            ${posts.map(p => renderRow(p)).join('')}
          </tbody>
        </table>
      </div>
    `

    document.getElementById('admin-blog-tbody')?.addEventListener('click', async (e) => {
      const deleteBtn = e.target.closest('[data-delete]')
      if (deleteBtn) {
        const id = deleteBtn.dataset.delete
        const title = deleteBtn.dataset.title
        if (!confirm(`Delete "${title}"? This cannot be undone.`)) return
        deleteBtn.disabled = true
        deleteBtn.textContent = 'Deleting…'
        try {
          await deleteBlogPost(id)
          document.getElementById(`blog-row-${CSS.escape(id)}`)?.remove()
        } catch (err) {
          alert('Failed to delete: ' + (err.message || 'Unknown error'))
          deleteBtn.disabled = false
          deleteBtn.textContent = 'Delete'
        }
      }
    })
  } catch (err) {
    content.innerHTML = `<div class="admin-error">Failed to load posts: ${err.message}</div>`
  }
}

function renderRow(p) {
  const statusClass = p.status === 'published' ? 'admin-badge-active'
    : p.status === 'scheduled' ? 'admin-badge-warning'
    : 'admin-badge-inactive'

  const publishDate = p.published_at
    ? new Date(p.published_at).toLocaleDateString()
    : p.publish_at
      ? `Scheduled: ${new Date(p.publish_at).toLocaleDateString()}`
      : '—'

  return `
    <tr id="blog-row-${CSS.escape(p.id)}">
      <td class="cell-name" title="${escapeHtml(p.title)}">${escapeHtml(p.title)}</td>
      <td class="cell-sku">${escapeHtml(p.slug)}</td>
      <td>
        <span class="admin-badge ${statusClass}">
          ${p.status.charAt(0).toUpperCase() + p.status.slice(1)}
        </span>
      </td>
      <td class="text-secondary text-sm">${publishDate}</td>
      <td class="cell-actions">
        <a href="#/admin/blog/${p.id}/edit" class="btn btn-sm" style="font-size: var(--text-xs);">Edit</a>
        <button
          class="btn btn-sm"
          style="font-size: var(--text-xs); border-color: var(--color-error); color: var(--color-error);"
          data-delete="${p.id}"
          data-title="${escapeHtml(p.title)}"
        >Delete</button>
      </td>
    </tr>
  `
}

function escapeHtml(str) {
  return String(str || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
